// extracted by mini-css-extract-plugin
export default {"wrapper":"AddProductCategory_wrapper__u3oF7"};